export const activitiesKeys = {
	all: ['crm', 'activities'],
	list: (filters) => ['crm', 'activities', 'list', filters],
	listInfinite: (filters) => ['crm', 'activities', 'listInfinite', filters],
	stats: (filters) => ['crm', 'activities', 'stats', filters],
	byDeal: (dealId) => ['crm', 'activities', 'byDeal', dealId],
	byCompany: (companyId) => ['crm', 'activities', 'byCompany', companyId],
};

export const activitiesMutationKeys = {
	create: ['crm', 'activities', 'create'],
	bulkCreateByDeals: ['crm', 'activities', 'bulkCreateByDeals'],
	bulkCreateByCompanies: ['crm', 'activities', 'bulkCreateByCompanies'],
	update: ['crm', 'activities', 'update'],
	complete: ['crm', 'activities', 'complete'],
	delete: ['crm', 'activities', 'delete'],
};
